<p-toast></p-toast>
<div
  class="surface-ground flex align-items-center justify-content-center min-h-screen min-w-screen overflow-hidden"
>
  <div class="flex flex-column align-items-center justify-content-center">
    <img src="assets/layout/images/logo.png" alt="UVEMA logo" class="mb-5 w-6rem flex-shrink-0" />
    <div
      style="
        border-radius: 56px;
        padding: 0.3rem;
        background: linear-gradient(180deg, rgba(0, 146, 156, 0.4) 10%, rgba(33, 150, 243, 0) 30%);
      "
    >
      <div class="w-full surface-card py-8 px-5 sm:px-8" style="border-radius: 53px">
        <form [formGroup]="form" (ngSubmit)="onSubmit()">
          <div class="field">
            <span class="p-float-label">
              <input
                id="email"
                type="text"
                pInputText
                class="w-full md:w-30rem"
                formControlName="email"
              />
              <label for="inputtext">Email</label>
            </span>
            @if (emailIsInvalid) {
            <small class="p-error">Email inválido</small>
            }
          </div>

          <div class="field">
            <span class="p-float-label">
              <p-password
                formControlName="password"
                id="password"
                [toggleMask]="true"
                [feedback]="false"
                inputStyleClass="w-full md:w-30rem"
              ></p-password>
              <label for="password">Password</label>
            </span>
            @if (passwordIsInvalid) {
            <small class="p-error">Campo requerido</small>
            }
          </div>
          <div class="flex align-items-center justify-content-between"></div>
          <p-button
            type="submit"
            [loading]="loading"
            styleClass="w-full text-xl"
            label="Login"
            onKeyPress=""
          />
        </form>
      </div>
    </div>
  </div>
</div>
